/* ts-unified-collection-filters-20260814 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ts-shared-filter]').forEach(function (tools) {
    var button = tools.querySelector('[data-ts-shared-filter-toggle]');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.addEventListener('click', function () {
      var opening = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      panel.hidden = !opening;
      if (opening && window.matchMedia('(max-width: 749px)').matches) {
        window.setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 20);
      }
    });
  });
});


/* ts-speaker-amplifier-filter-alignment-20260814 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ts-speaker-filter-tools]').forEach(function (tools) {
    var button = tools.querySelector('[data-ts-speaker-filter-toggle]');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.addEventListener('click', function () {
      var opening = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      panel.hidden = !opening;
      if (opening && window.matchMedia('(max-width: 749px)').matches) {
        window.setTimeout(function () { panel.scrollIntoView({behavior:'smooth',block:'nearest'}); }, 20);
      }
    });
  });
});
